const Input = (props) => {
  const boxStyle = props.noMarginBottom
    ? `mb-0 flex flex-col ${props.className || ''}`
    : `mb-8 flex flex-col ${props.className || ''}`;
  const boxStyleObj = (props.maxWidth || props.width)
    ? {
        ...(props.maxWidth && { maxWidth: props.maxWidth }),
        ...(props.width && { width: props.width }),
      }
    : undefined;
  const inputWidth = props.inputWidth ?? props.width;
  const inputStyle = inputWidth ? { width: inputWidth } : undefined;
  const readOnlyCls = props.readOnly
    ? "cursor-default select-none hover:border-border"
    : "hover:border-border-strong";

  if (props.enablePasswordToggle) {
    return (
      <div className={boxStyle} style={boxStyleObj}>
        <label
          htmlFor={props.name}
          className="block mb-1 text-sm font-regular text-text-2 focus:outline-none"
        >
          {props.title}
        </label>
        <input
          type={props.type}
          autoComplete={props.autocomplete}
          className={`form-control border border-border ${inputWidth ? "" : "w-full"} h-11 p-2 rounded-ctrl focus:border-primary focus:border-2 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-bg focus-visible:border-border-strong focus-visible:outline-none ${readOnlyCls} ${props.inputClassName ?? ""}`}
          style={inputStyle}
          id={props.name}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          placeholder={props.placeholder}
          autoFocus={props.autoFocus}
          readOnly={props.readOnly}
        />
      </div>
    );
  } else {
    const inputEl = (
      <input
        type={props.type}
        autoComplete={props.autocomplete}
        className={`form-control border border-border ${inputWidth ? "" : "w-full"} h-11 p-2 rounded-ctrl focus-visible:ring-1 focus-visible:ring-primary focus-visible:ring-offset-0 focus-visible:ring-offset-bg focus-visible:border-primary focus-visible:outline-none ${readOnlyCls} ${props.icon ? "pl-9" : ""} ${props.inputClassName || ""}`}
        style={inputStyle}
        id={props.name}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        placeholder={props.placeholder}
        autoFocus={props.autoFocus}
        readOnly={props.readOnly}
        data-1p-ignore
        data-lpignore="true"
        data-bwignore
      />
    );

    return (
      <div className={boxStyle} style={boxStyleObj}>
        {props.title && (
          <label
            htmlFor={props.name}
            className="block mb-1 text-sm font-regular text-text-2 focus:outline-none"
          >
            {props.title}
          </label>
        )}
        {props.icon ? (
          <div className="relative w-full">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-text-3 pointer-events-none">
              {props.icon}
            </span>
            {inputEl}
          </div>
        ) : (
          inputEl
        )}
      </div>
    );
  }
};

export default Input;